var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{ref:"modal",staticClass:"modal-style",attrs:{"name":"adminModal","adaptive":true,"height":"auto","width":_vm.modalWidth,"clickToClose":_vm.modalItem.background},on:{"closed":_vm.closeModal}},[_c(_vm.modalItem.type,{tag:"component",staticClass:"lp-modal-wrapper",attrs:{"data":_vm.modalItem.value}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }